var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResizeNesw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 5L5 19M19 5v5M19 5h-5M5 19v-5M5 19h5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 5L5 19M19 5v5M19 5h-5M5 19v-5M5 19h5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeNesw);
export default __webpack_public_path__ + "static/media/resize_nesw.6f5ba49a64df5678cd60ca1a12c22245.svg";
export { ForwardRef as ReactComponent };